import React from "react";

import Logo from "../../assets/dp.jpg";
import {
  LinkedinLogo,
  EnvelopeSimple,
  GithubLogo,
} from "@phosphor-icons/react";

const DepartmentCard = ({ data }) => {
  return (
    <div className="flex flex-col items-center justify-center m-4">
      <img
        className="object-cover w-24 h-24 shadow-xl  rounded-full mb-2"
        src={data.image}
      />
      <p className="text-center font-semibold text-xl mb-2">{data.firstname}</p>
      <div className="flex justify-center gap-x-4">
        <a href={data.linkedIn} target="_blank">
          <LinkedinLogo
            size={24}
            color="#4be4c0"
            className="hover:fill-[#fff] hover:scale-110  transition duration-300 ease-in-out"
          />
        </a>
        <a href={`mailto:${data.email}`}>
          <EnvelopeSimple
            size={24}
            color="#4be4c0"
            className="hover:fill-[#fff] hover:scale-110 transition duration-300 ease-in-out"
          />
        </a>
      </div>
    </div>
  );
};

export default DepartmentCard;
